/**
 * Created by staffanrantzow on 10/11/16.
 */

export default class LoyaltyPointsTypeEntity {

  constructor (
    id,
    amount,
    companyName,
    expiresAt,
    factor,
    loyaltyableId,
    loyaltyableType,
    status,
    createdAt,
    deletedAt,
    updatedAt
  ) {
    this.id = id;
    this.amount = amount;
    this.companyName = companyName;
    this.expires_at = expiresAt;
    this.factor = factor;
    this.loyaltyableId = loyaltyableId;
    this.loyaltyableType = loyaltyableType;
    this.status = status;
    this.createdAt = createdAt;
    this.deletedAt = deletedAt;
    this.updatedAt = updatedAt;
  }

}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/loyalty-points/loyalty-point-type-entity.js
 **/